
import { defineComponent, reactive, onMounted, toRefs, computed } from "vue";
// import ErrorList from "@/components/commonDesign/ErrorList.vue";
import { ethitransService } from "@/services/EthitransService.ts";
import { common } from "@/common/services/Common.ts";
import { config } from "@/Config";

export default defineComponent({
  name: "ActivityCard",
  components: {
    // ErrorList, // googleAuth
    // facebookLogin
  },
  props: {
    activity: Object,
  },
  setup(props: any) {
    const state = reactive({
      data: {
        imageBaseUrl: "",
      },
      ui: {
        postLoading: {
          processRegistration: false,
        },
      },
    });
    onMounted(() => {
      state.data.imageBaseUrl = config.imageBaseUrl;
    });
     // Convert timestamp to local device date and time
     const localTimestamp = computed(() => {
      if (!props.activity?.activity_date_timestamp) return ''
      const date = new Date(props.activity.activity_date_timestamp)
      return date.toLocaleString(undefined, {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      })
    })
    return {
      ...toRefs(state),
      localTimestamp,
    };
  },
});
